export default __webpack_public_path__ + "static/media/COVIDLiveUpdate.4b83f784.svg";